import { useQuery, UseQueryResult } from "react-query";
import { FinancialReportResponse } from "api/types";
import {
  FinancialReportParams,
  getFinancialReport,
} from "services/reports";

/**
 * Charge le rapport financier sur la plage `from`/`to`.
 *
 * <p>{@code enabled} : tant que `from` ou `to` est vide, on ne tire pas
 * l'appel pour ne pas renvoyer du 400. Une fois les dates posées, la
 * query refetch automatiquement quand n'importe quel filtre change
 * (incluse dans la clé).
 *
 * <p>Le `select` déballe l'enveloppe `apiRequest` ({ok, status, data})
 * en `FinancialReportResponse` direct pour les consommateurs.
 */
export function useFinancialReport(
  params: FinancialReportParams
): UseQueryResult<FinancialReportResponse | undefined> {
  return useQuery<any, unknown, FinancialReportResponse | undefined>(
    ["financial-report", params],
    () => getFinancialReport(params),
    {
      enabled: Boolean(params.from && params.to),
      keepPreviousData: true,
      staleTime: 60 * 1000,
      select: (result: any) =>
        result?.ok ? (result.data as FinancialReportResponse) : undefined,
    }
  );
}

export default useFinancialReport;
